/* tslint:disable */
/* eslint-disable */
/**
 * Swagger Corporate Site API
 * This is a rest-api server.
 *
 * OpenAPI spec version: 1.0
 * Contact: support@swagger.io
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */
import globalAxios, { AxiosPromise, AxiosInstance } from 'axios';
import { Configuration } from '../configuration';
// Some imports not used depending on template conditions
// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS, RequestArgs, BaseAPI, RequiredError } from '../base';
import { ContractsReference } from '../models';
import { ContractsWrappedError } from '../models';
import { GitlabServicesMtsRuMtsMediaCorporateBackendProjectsCountableResult } from '../models';
import { GitlabServicesMtsRuMtsMediaCorporateBackendProjectsProject } from '../models';
import { GitlabServicesMtsRuMtsMediaCorporateCorporateBackendProjectsCountableResult } from '../models';
import { GitlabServicesMtsRuMtsMediaCorporateCorporateBackendProjectsPathProjectRequest } from '../models';
import { GitlabServicesMtsRuMtsMediaCorporateCorporateBackendProjectsProject } from '../models';
import { GitlabServicesMtsRuMtsMediaCorporateCorporateBackendProjectsReorderProjectsRequest } from '../models';
/**
 * ProjectsApi - axios parameter creator
 * @export
 */
export const ProjectsApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * Удаление проекта
         * @summary Удаление проекта
         * @param {string} uid identificator of project
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteProject: async (uid: string, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'uid' is not null or undefined
            if (uid === null || uid === undefined) {
                throw new RequiredError('uid','Required parameter uid was null or undefined when calling deleteProject.');
            }
            const localVarPath = `/api/corpsite/v1/projects/{uid}`
                .replace(`{${"uid"}}`, encodeURIComponent(String(uid)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, 'https://example.com');
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            const query = new URLSearchParams(localVarUrlObj.search);
            for (const key in localVarQueryParameter) {
                query.set(key, localVarQueryParameter[key]);
            }
            for (const key in options.query) {
                query.set(key, options.query[key]);
            }
            localVarUrlObj.search = (new URLSearchParams(query)).toString();
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Endpoint for download files from public location
         * @param {string} uid Имя скачиваемого файла
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        dowloadProjectsImagesPublic: async (uid: string, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'uid' is not null or undefined
            if (uid === null || uid === undefined) {
                throw new RequiredError('uid','Required parameter uid was null or undefined when calling dowloadProjectsImagesPublic.');
            }
            const localVarPath = `/api/corpsite/v1/projects/download/public/{uid}`
                .replace(`{${"uid"}}`, encodeURIComponent(String(uid)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, 'https://example.com');
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            const query = new URLSearchParams(localVarUrlObj.search);
            for (const key in localVarQueryParameter) {
                query.set(key, localVarQueryParameter[key]);
            }
            for (const key in options.query) {
                query.set(key, options.query[key]);
            }
            localVarUrlObj.search = (new URLSearchParams(query)).toString();
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Получение размера коллекции в соотвествии с фильтром
         * @param {string} [dateFromStart] Фильтр по дате начала от 2006-01-02T15:04:05.000Z
         * @param {string} [dateFromEnd] Фильтр по дате начала до 2006-01-02T15:04:05.000Z
         * @param {number} [projectAssessmentFrom] Фильтр по стоимости  от
         * @param {number} [projectAssessmentTo] Фильтр по стоимости до
         * @param {Array&lt;number&gt;} [genre] Фильтр по жанру
         * @param {Array&lt;number&gt;} [projectStatus] Фильтр по статусу проекта
         * @param {Array&lt;number&gt;} [ProjectType] Фильтр по типу проекта
         * @param {string} [searchString] Фильтр по наименованию+режиссеру+продюсеру
         * @param {Array&lt;number&gt;} [SpecialCategoryType] Фильтрация по лидер / премьера
         * @param {string} [author] Фильтр по автору (me -  текущий пользователь)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getProjectCollectionSize: async (dateFromStart?: string, dateFromEnd?: string, projectAssessmentFrom?: number, projectAssessmentTo?: number, genre?: Array<number>, projectStatus?: Array<number>, ProjectType?: Array<number>, searchString?: string, SpecialCategoryType?: Array<number>, author?: string, options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/corpsite/v1/projects/total`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, 'https://example.com');
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (dateFromStart !== undefined) {
                localVarQueryParameter['dateFromStart'] = dateFromStart;
            }

            if (dateFromEnd !== undefined) {
                localVarQueryParameter['dateFromEnd'] = dateFromEnd;
            }

            if (projectAssessmentFrom !== undefined) {
                localVarQueryParameter['projectAssessmentFrom'] = projectAssessmentFrom;
            }

            if (projectAssessmentTo !== undefined) {
                localVarQueryParameter['projectAssessmentTo'] = projectAssessmentTo;
            }

            if (genre) {
                localVarQueryParameter['genre'] = genre.join(COLLECTION_FORMATS.csv);
            }

            if (projectStatus) {
                localVarQueryParameter['projectStatus'] = projectStatus.join(COLLECTION_FORMATS.csv);
            }

            if (ProjectType) {
                localVarQueryParameter['ProjectType'] = ProjectType.join(COLLECTION_FORMATS.csv);
            }

            if (searchString !== undefined) {
                localVarQueryParameter['searchString'] = searchString;
            }

            if (SpecialCategoryType) {
                localVarQueryParameter['SpecialCategoryType'] = SpecialCategoryType.join(COLLECTION_FORMATS.csv);
            }

            if (author !== undefined) {
                localVarQueryParameter['author'] = author;
            }

            const query = new URLSearchParams(localVarUrlObj.search);
            for (const key in localVarQueryParameter) {
                query.set(key, localVarQueryParameter[key]);
            }
            for (const key in options.query) {
                query.set(key, options.query[key]);
            }
            localVarUrlObj.search = (new URLSearchParams(query)).toString();
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
                options: localVarRequestOptions,
            };
        },
        /**
         * Получение проекта по id
         * @summary Получение проекта по id
         * @param {string} id identificator of project
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getProjectEntity: async (id: string, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            if (id === null || id === undefined) {
                throw new RequiredError('id','Required parameter id was null or undefined when calling getProjectEntity.');
            }
            const localVarPath = `/api/corpsite/v1/projects/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, 'https://example.com');
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            const query = new URLSearchParams(localVarUrlObj.search);
            for (const key in localVarQueryParameter) {
                query.set(key, localVarQueryParameter[key]);
            }
            for (const key in options.query) {
                query.set(key, options.query[key]);
            }
            localVarUrlObj.search = (new URLSearchParams(query)).toString();
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
                options: localVarRequestOptions,
            };
        },
        /**
         * Получение опубликованного проекта по id (неавторизованая зона)
         * @summary Получение опубликованного проекта по id (неавторизованая зона)
         * @param {string} id Id опубликованного проекта
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getProjectPublishedEntity: async (id: string, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            if (id === null || id === undefined) {
                throw new RequiredError('id','Required parameter id was null or undefined when calling getProjectPublishedEntity.');
            }
            const localVarPath = `/api/corpsite/v1/projects/published/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, 'https://example.com');
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            const query = new URLSearchParams(localVarUrlObj.search);
            for (const key in localVarQueryParameter) {
                query.set(key, localVarQueryParameter[key]);
            }
            for (const key in options.query) {
                query.set(key, options.query[key]);
            }
            localVarUrlObj.search = (new URLSearchParams(query)).toString();
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Получение коллекции в соотвествии с фильтром
         * @param {number} [size] Количество выдаваемых строк, по умолчанию 10
         * @param {number} [offset] Смещение от начала
         * @param {string} [dateFromStart] Фильтр по дате начала от 2006-01-02T15:04:05.000Z
         * @param {string} [dateFromEnd] Фильтр по дате начала до 2006-01-02T15:04:05.000Z
         * @param {boolean} [displayOnHomePage] При передаче значения true будут выданы только проекты с флагом -показывать на главной-
         * @param {number} [projectAssessmentFrom] Фильтр по стоимости от
         * @param {number} [projectAssessmentTo] Фильтр по стоимости до
         * @param {Array&lt;number&gt;} [genre] Фильтр по жанру
         * @param {Array&lt;number&gt;} [projectStatus] Фильтр по статусу проекта
         * @param {Array&lt;number&gt;} [ProjectType] Фильтр по типу проекта
         * @param {string} [sortField] Сортировка по полю
         * @param {number} [sortDirection] направление сортировки
         * @param {Array&lt;number&gt;} [SpecialCategoryType] Фильтрация по лидер / премьера
         * @param {string} [searchString] Фильтр по наименованию+режиссеру+продюсеру
         * @param {string} [author] Фильтр по автору (me - текущий пользователь)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getProjectsListFilter: async (size?: number, offset?: number, dateFromStart?: string, dateFromEnd?: string, displayOnHomePage?: boolean, projectAssessmentFrom?: number, projectAssessmentTo?: number, genre?: Array<number>, projectStatus?: Array<number>, ProjectType?: Array<number>, sortField?: string, sortDirection?: number, SpecialCategoryType?: Array<number>, searchString?: string, author?: string, options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/corpsite/v1/projects`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, 'https://example.com');
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (size !== undefined) {
                localVarQueryParameter['size'] = size;
            }

            if (offset !== undefined) {
                localVarQueryParameter['offset'] = offset;
            }

            if (dateFromStart !== undefined) {
                localVarQueryParameter['dateFromStart'] = dateFromStart;
            }

            if (dateFromEnd !== undefined) {
                localVarQueryParameter['dateFromEnd'] = dateFromEnd;
            }

            if (displayOnHomePage !== undefined) {
                localVarQueryParameter['displayOnHomePage'] = displayOnHomePage;
            }

            if (projectAssessmentFrom !== undefined) {
                localVarQueryParameter['projectAssessmentFrom'] = projectAssessmentFrom;
            }

            if (projectAssessmentTo !== undefined) {
                localVarQueryParameter['projectAssessmentTo'] = projectAssessmentTo;
            }

            if (genre) {
                localVarQueryParameter['genre'] = genre.join(COLLECTION_FORMATS.csv);
            }

            if (projectStatus) {
                localVarQueryParameter['projectStatus'] = projectStatus.join(COLLECTION_FORMATS.csv);
            }

            if (ProjectType) {
                localVarQueryParameter['ProjectType'] = ProjectType.join(COLLECTION_FORMATS.csv);
            }

            if (sortField !== undefined) {
                localVarQueryParameter['sortField'] = sortField;
            }

            if (sortDirection !== undefined) {
                localVarQueryParameter['sortDirection'] = sortDirection;
            }

            if (SpecialCategoryType) {
                localVarQueryParameter['SpecialCategoryType'] = SpecialCategoryType.join(COLLECTION_FORMATS.csv);
            }

            if (searchString !== undefined) {
                localVarQueryParameter['searchString'] = searchString;
            }

            if (author !== undefined) {
                localVarQueryParameter['author'] = author;
            }

            const query = new URLSearchParams(localVarUrlObj.search);
            for (const key in localVarQueryParameter) {
                query.set(key, localVarQueryParameter[key]);
            }
            for (const key in options.query) {
                query.set(key, options.query[key]);
            }
            localVarUrlObj.search = (new URLSearchParams(query)).toString();
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Получение списка опубликованных проектов (неавторизованая зона)
         * @param {number} [size] Количество выдаваемых строк, по умолчанию 10
         * @param {number} [offset] Смещение от начала
         * @param {boolean} [displayOnHomePage] При передаче значения true будут выданы только проекты с флагом -показывать на главной-
         * @param {Array&lt;number&gt;} [ProjectType] Фильтр по типу проекта
         * @param {string} [searchString] Фильтр по наименованию+режиссеру+продюсеру
         * @param {Array&lt;number&gt;} [genre] Фильтр по жанру
         * @param {string} [sortField] Сортировка по полю
         * @param {number} [sortDirection] направление сортировки
         * @param {Array&lt;number&gt;} [SpecialCategoryType] Фильтрация по лидер (1) / премьера (2)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getProjectsListPublished: async (size?: number, offset?: number, displayOnHomePage?: boolean, ProjectType?: Array<number>, searchString?: string, genre?: Array<number>, sortField?: string, sortDirection?: number, SpecialCategoryType?: Array<number>, options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/corpsite/v1/projects/published/`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, 'https://example.com');
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (size !== undefined) {
                localVarQueryParameter['size'] = size;
            }

            if (offset !== undefined) {
                localVarQueryParameter['offset'] = offset;
            }

            if (displayOnHomePage !== undefined) {
                localVarQueryParameter['displayOnHomePage'] = displayOnHomePage;
            }

            if (ProjectType) {
                localVarQueryParameter['ProjectType'] = ProjectType.join(COLLECTION_FORMATS.csv);
            }

            if (searchString !== undefined) {
                localVarQueryParameter['searchString'] = searchString;
            }

            if (genre) {
                localVarQueryParameter['genre'] = genre.join(COLLECTION_FORMATS.csv);
            }

            if (sortField !== undefined) {
                localVarQueryParameter['sortField'] = sortField;
            }

            if (sortDirection !== undefined) {
                localVarQueryParameter['sortDirection'] = sortDirection;
            }

            if (SpecialCategoryType) {
                localVarQueryParameter['SpecialCategoryType'] = SpecialCategoryType.join(COLLECTION_FORMATS.csv);
            }

            const query = new URLSearchParams(localVarUrlObj.search);
            for (const key in localVarQueryParameter) {
                query.set(key, localVarQueryParameter[key]);
            }
            for (const key in options.query) {
                query.set(key, options.query[key]);
            }
            localVarUrlObj.search = (new URLSearchParams(query)).toString();
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
                options: localVarRequestOptions,
            };
        },
        /**
         * Получение списка проектов в соответствии с фильтром + дополнительно черновик по id
         * @summary Получение списка проектов в соответствии с фильтром + дополнительно черновик по id
         * @param {string} id id проекта-черновика, которого надо присоединить к результату
         * @param {number} [size] Количество выдаваемых строк, по умолчанию 10
         * @param {number} [offset] Смещение от начала
         * @param {boolean} [displayOnHomePage] При передаче значения true будут выданы только проекты с флагом -показывать на главной-
         * @param {Array&lt;number&gt;} [ProjectType] Фильтр по типу проекта
         * @param {string} [searchString] Фильтр по наименованию+режиссеру+продюсеру
         * @param {Array&lt;number&gt;} [genre] Фильтр по жанру
         * @param {string} [sortField] Сортировка по полю
         * @param {number} [sortDirection] направление сортировки
         * @param {Array&lt;number&gt;} [SpecialCategoryType] Фильтрация по лидер (1) / премьера (2)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getProjectsListWithDraft: async (id: string, size?: number, offset?: number, displayOnHomePage?: boolean, ProjectType?: Array<number>, searchString?: string, genre?: Array<number>, sortField?: string, sortDirection?: number, SpecialCategoryType?: Array<number>, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            if (id === null || id === undefined) {
                throw new RequiredError('id','Required parameter id was null or undefined when calling getProjectsListWithDraft.');
            }
            const localVarPath = `/api/corpsite/v1/projects/draft/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, 'https://example.com');
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (size !== undefined) {
                localVarQueryParameter['size'] = size;
            }

            if (offset !== undefined) {
                localVarQueryParameter['offset'] = offset;
            }

            if (displayOnHomePage !== undefined) {
                localVarQueryParameter['displayOnHomePage'] = displayOnHomePage;
            }

            if (ProjectType) {
                localVarQueryParameter['ProjectType'] = ProjectType.join(COLLECTION_FORMATS.csv);
            }

            if (searchString !== undefined) {
                localVarQueryParameter['searchString'] = searchString;
            }

            if (genre) {
                localVarQueryParameter['genre'] = genre.join(COLLECTION_FORMATS.csv);
            }

            if (sortField !== undefined) {
                localVarQueryParameter['sortField'] = sortField;
            }

            if (sortDirection !== undefined) {
                localVarQueryParameter['sortDirection'] = sortDirection;
            }

            if (SpecialCategoryType) {
                localVarQueryParameter['SpecialCategoryType'] = SpecialCategoryType.join(COLLECTION_FORMATS.csv);
            }

            const query = new URLSearchParams(localVarUrlObj.search);
            for (const key in localVarQueryParameter) {
                query.set(key, localVarQueryParameter[key]);
            }
            for (const key in options.query) {
                query.set(key, options.query[key]);
            }
            localVarUrlObj.search = (new URLSearchParams(query)).toString();
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
                options: localVarRequestOptions,
            };
        },
        /**
         * Получение справочников РМ управления проектами
         * @summary Получение справочников
         * @param {string} name Значения: genre, age_restrictions, production_status, roles status, type, special_category
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getProjectsReferences: async (name: string, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'name' is not null or undefined
            if (name === null || name === undefined) {
                throw new RequiredError('name','Required parameter name was null or undefined when calling getProjectsReferences.');
            }
            const localVarPath = `/api/corpsite/v1/projects/reference`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, 'https://example.com');
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (name !== undefined) {
                localVarQueryParameter['name'] = name;
            }

            const query = new URLSearchParams(localVarUrlObj.search);
            for (const key in localVarQueryParameter) {
                query.set(key, localVarQueryParameter[key]);
            }
            for (const key in options.query) {
                query.set(key, options.query[key]);
            }
            localVarUrlObj.search = (new URLSearchParams(query)).toString();
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
                options: localVarRequestOptions,
            };
        },
        /**
         * Изменение параметров существующего проекта (метод доступен только модератору)
         * @summary Изменение параметров проекта
         * @param {GitlabServicesMtsRuMtsMediaCorporateCorporateBackendProjectsPathProjectRequest} body Информация о новом пользователе
         * @param {string} uid Идентификатор пользователя
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        pathProject: async (body: GitlabServicesMtsRuMtsMediaCorporateCorporateBackendProjectsPathProjectRequest, uid: string, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'body' is not null or undefined
            if (body === null || body === undefined) {
                throw new RequiredError('body','Required parameter body was null or undefined when calling pathProject.');
            }
            // verify required parameter 'uid' is not null or undefined
            if (uid === null || uid === undefined) {
                throw new RequiredError('uid','Required parameter uid was null or undefined when calling pathProject.');
            }
            const localVarPath = `/api/corpsite/v1/projects/{uid}`
                .replace(`{${"uid"}}`, encodeURIComponent(String(uid)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, 'https://example.com');
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'PATCH', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            localVarHeaderParameter['Content-Type'] = 'application/json';

            const query = new URLSearchParams(localVarUrlObj.search);
            for (const key in localVarQueryParameter) {
                query.set(key, localVarQueryParameter[key]);
            }
            for (const key in options.query) {
                query.set(key, options.query[key]);
            }
            localVarUrlObj.search = (new URLSearchParams(query)).toString();
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            const needsSerialization = (typeof body !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.data =  needsSerialization ? JSON.stringify(body !== undefined ? body : {}) : (body || "");

            return {
                url: localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
                options: localVarRequestOptions,
            };
        },
        /**
         * Изменение позиции существующих проектов (перетаскивание проктов в списке проектов)
         * @summary Изменение параметров проекта
         * @param {GitlabServicesMtsRuMtsMediaCorporateCorporateBackendProjectsReorderProjectsRequest} body Информация о проектах с измененной позицией
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        reorderProjects: async (body: GitlabServicesMtsRuMtsMediaCorporateCorporateBackendProjectsReorderProjectsRequest, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'body' is not null or undefined
            if (body === null || body === undefined) {
                throw new RequiredError('body','Required parameter body was null or undefined when calling reorderProjects.');
            }
            const localVarPath = `/api/corpsite/v1/projects/reorder`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, 'https://example.com');
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'PATCH', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            localVarHeaderParameter['Content-Type'] = 'application/json';

            const query = new URLSearchParams(localVarUrlObj.search);
            for (const key in localVarQueryParameter) {
                query.set(key, localVarQueryParameter[key]);
            }
            for (const key in options.query) {
                query.set(key, options.query[key]);
            }
            localVarUrlObj.search = (new URLSearchParams(query)).toString();
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            const needsSerialization = (typeof body !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.data =  needsSerialization ? JSON.stringify(body !== undefined ? body : {}) : (body || "");

            return {
                url: localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
                options: localVarRequestOptions,
            };
        },
        /**
         * Сохранение проекта
         * @summary Сохранение проекта
         * @param {GitlabServicesMtsRuMtsMediaCorporateCorporateBackendProjectsProject} body Сохранение проекта в хранилище
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        saveProject: async (body: GitlabServicesMtsRuMtsMediaCorporateCorporateBackendProjectsProject, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'body' is not null or undefined
            if (body === null || body === undefined) {
                throw new RequiredError('body','Required parameter body was null or undefined when calling saveProject.');
            }
            const localVarPath = `/api/corpsite/v1/projects`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, 'https://example.com');
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            localVarHeaderParameter['Content-Type'] = 'application/json';

            const query = new URLSearchParams(localVarUrlObj.search);
            for (const key in localVarQueryParameter) {
                query.set(key, localVarQueryParameter[key]);
            }
            for (const key in options.query) {
                query.set(key, options.query[key]);
            }
            localVarUrlObj.search = (new URLSearchParams(query)).toString();
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            const needsSerialization = (typeof body !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.data =  needsSerialization ? JSON.stringify(body !== undefined ? body : {}) : (body || "");

            return {
                url: localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * ProjectsApi - functional programming interface
 * @export
 */
export const ProjectsApiFp = function(configuration?: Configuration) {
    return {
        /**
         * Удаление проекта
         * @summary Удаление проекта
         * @param {string} uid identificator of project
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async deleteProject(uid: string, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<string>> {
            const localVarAxiosArgs = await ProjectsApiAxiosParamCreator(configuration).deleteProject(uid, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * 
         * @summary Endpoint for download files from public location
         * @param {string} uid Имя скачиваемого файла
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async dowloadProjectsImagesPublic(uid: string, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<string>> {
            const localVarAxiosArgs = await ProjectsApiAxiosParamCreator(configuration).dowloadProjectsImagesPublic(uid, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * 
         * @summary Получение размера коллекции в соотвествии с фильтром
         * @param {string} [dateFromStart] Фильтр по дате начала от 2006-01-02T15:04:05.000Z
         * @param {string} [dateFromEnd] Фильтр по дате начала до 2006-01-02T15:04:05.000Z
         * @param {number} [projectAssessmentFrom] Фильтр по стоимости  от
         * @param {number} [projectAssessmentTo] Фильтр по стоимости до
         * @param {Array&lt;number&gt;} [genre] Фильтр по жанру
         * @param {Array&lt;number&gt;} [projectStatus] Фильтр по статусу проекта
         * @param {Array&lt;number&gt;} [ProjectType] Фильтр по типу проекта
         * @param {string} [searchString] Фильтр по наименованию+режиссеру+продюсеру
         * @param {Array&lt;number&gt;} [SpecialCategoryType] Фильтрация по лидер / премьера
         * @param {string} [author] Фильтр по автору (me -  текущий пользователь)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getProjectCollectionSize(dateFromStart?: string, dateFromEnd?: string, projectAssessmentFrom?: number, projectAssessmentTo?: number, genre?: Array<number>, projectStatus?: Array<number>, ProjectType?: Array<number>, searchString?: string, SpecialCategoryType?: Array<number>, author?: string, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<number>> {
            const localVarAxiosArgs = await ProjectsApiAxiosParamCreator(configuration).getProjectCollectionSize(dateFromStart, dateFromEnd, projectAssessmentFrom, projectAssessmentTo, genre, projectStatus, ProjectType, searchString, SpecialCategoryType, author, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * Получение проекта по id
         * @summary Получение проекта по id
         * @param {string} id identificator of project
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getProjectEntity(id: string, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GitlabServicesMtsRuMtsMediaCorporateCorporateBackendProjectsProject>> {
            const localVarAxiosArgs = await ProjectsApiAxiosParamCreator(configuration).getProjectEntity(id, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * Получение опубликованного проекта по id (неавторизованая зона)
         * @summary Получение опубликованного проекта по id (неавторизованая зона)
         * @param {string} id Id опубликованного проекта
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getProjectPublishedEntity(id: string, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GitlabServicesMtsRuMtsMediaCorporateBackendProjectsProject>> {
            const localVarAxiosArgs = await ProjectsApiAxiosParamCreator(configuration).getProjectPublishedEntity(id, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * 
         * @summary Получение коллекции в соотвествии с фильтром
         * @param {number} [size] Количество выдаваемых строк, по умолчанию 10
         * @param {number} [offset] Смещение от начала
         * @param {string} [dateFromStart] Фильтр по дате начала от 2006-01-02T15:04:05.000Z
         * @param {string} [dateFromEnd] Фильтр по дате начала до 2006-01-02T15:04:05.000Z
         * @param {boolean} [displayOnHomePage] При передаче значения true будут выданы только проекты с флагом -показывать на главной-
         * @param {number} [projectAssessmentFrom] Фильтр по стоимости от
         * @param {number} [projectAssessmentTo] Фильтр по стоимости до
         * @param {Array&lt;number&gt;} [genre] Фильтр по жанру
         * @param {Array&lt;number&gt;} [projectStatus] Фильтр по статусу проекта
         * @param {Array&lt;number&gt;} [ProjectType] Фильтр по типу проекта
         * @param {string} [sortField] Сортировка по полю
         * @param {number} [sortDirection] направление сортировки
         * @param {Array&lt;number&gt;} [SpecialCategoryType] Фильтрация по лидер / премьера
         * @param {string} [searchString] Фильтр по наименованию+режиссеру+продюсеру
         * @param {string} [author] Фильтр по автору (me - текущий пользователь)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getProjectsListFilter(size?: number, offset?: number, dateFromStart?: string, dateFromEnd?: string, displayOnHomePage?: boolean, projectAssessmentFrom?: number, projectAssessmentTo?: number, genre?: Array<number>, projectStatus?: Array<number>, ProjectType?: Array<number>, sortField?: string, sortDirection?: number, SpecialCategoryType?: Array<number>, searchString?: string, author?: string, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<GitlabServicesMtsRuMtsMediaCorporateCorporateBackendProjectsProject>>> {
            const localVarAxiosArgs = await ProjectsApiAxiosParamCreator(configuration).getProjectsListFilter(size, offset, dateFromStart, dateFromEnd, displayOnHomePage, projectAssessmentFrom, projectAssessmentTo, genre, projectStatus, ProjectType, sortField, sortDirection, SpecialCategoryType, searchString, author, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * 
         * @summary Получение списка опубликованных проектов (неавторизованая зона)
         * @param {number} [size] Количество выдаваемых строк, по умолчанию 10
         * @param {number} [offset] Смещение от начала
         * @param {boolean} [displayOnHomePage] При передаче значения true будут выданы только проекты с флагом -показывать на главной-
         * @param {Array&lt;number&gt;} [ProjectType] Фильтр по типу проекта
         * @param {string} [searchString] Фильтр по наименованию+режиссеру+продюсеру
         * @param {Array&lt;number&gt;} [genre] Фильтр по жанру
         * @param {string} [sortField] Сортировка по полю
         * @param {number} [sortDirection] направление сортировки
         * @param {Array&lt;number&gt;} [SpecialCategoryType] Фильтрация по лидер (1) / премьера (2)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getProjectsListPublished(size?: number, offset?: number, displayOnHomePage?: boolean, ProjectType?: Array<number>, searchString?: string, genre?: Array<number>, sortField?: string, sortDirection?: number, SpecialCategoryType?: Array<number>, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GitlabServicesMtsRuMtsMediaCorporateBackendProjectsCountableResult>> {
            const localVarAxiosArgs = await ProjectsApiAxiosParamCreator(configuration).getProjectsListPublished(size, offset, displayOnHomePage, ProjectType, searchString, genre, sortField, sortDirection, SpecialCategoryType, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * Получение списка проектов в соответствии с фильтром + дополнительно черновик по id
         * @summary Получение списка проектов в соответствии с фильтром + дополнительно черновик по id
         * @param {string} id id проекта-черновика, которого надо присоединить к результату
         * @param {number} [size] Количество выдаваемых строк, по умолчанию 10
         * @param {number} [offset] Смещение от начала
         * @param {boolean} [displayOnHomePage] При передаче значения true будут выданы только проекты с флагом -показывать на главной-
         * @param {Array&lt;number&gt;} [ProjectType] Фильтр по типу проекта
         * @param {string} [searchString] Фильтр по наименованию+режиссеру+продюсеру
         * @param {Array&lt;number&gt;} [genre] Фильтр по жанру
         * @param {string} [sortField] Сортировка по полю
         * @param {number} [sortDirection] направление сортировки
         * @param {Array&lt;number&gt;} [SpecialCategoryType] Фильтрация по лидер (1) / премьера (2)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getProjectsListWithDraft(id: string, size?: number, offset?: number, displayOnHomePage?: boolean, ProjectType?: Array<number>, searchString?: string, genre?: Array<number>, sortField?: string, sortDirection?: number, SpecialCategoryType?: Array<number>, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GitlabServicesMtsRuMtsMediaCorporateCorporateBackendProjectsCountableResult>> {
            const localVarAxiosArgs = await ProjectsApiAxiosParamCreator(configuration).getProjectsListWithDraft(id, size, offset, displayOnHomePage, ProjectType, searchString, genre, sortField, sortDirection, SpecialCategoryType, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * Получение справочников РМ управления проектами
         * @summary Получение справочников
         * @param {string} name Значения: genre, age_restrictions, production_status, roles status, type, special_category
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getProjectsReferences(name: string, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<ContractsReference>>> {
            const localVarAxiosArgs = await ProjectsApiAxiosParamCreator(configuration).getProjectsReferences(name, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * Изменение параметров существующего проекта (метод доступен только модератору)
         * @summary Изменение параметров проекта
         * @param {GitlabServicesMtsRuMtsMediaCorporateCorporateBackendProjectsPathProjectRequest} body Информация о новом пользователе
         * @param {string} uid Идентификатор пользователя
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async pathProject(body: GitlabServicesMtsRuMtsMediaCorporateCorporateBackendProjectsPathProjectRequest, uid: string, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GitlabServicesMtsRuMtsMediaCorporateCorporateBackendProjectsProject>> {
            const localVarAxiosArgs = await ProjectsApiAxiosParamCreator(configuration).pathProject(body, uid, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * Изменение позиции существующих проектов (перетаскивание проктов в списке проектов)
         * @summary Изменение параметров проекта
         * @param {GitlabServicesMtsRuMtsMediaCorporateCorporateBackendProjectsReorderProjectsRequest} body Информация о проектах с измененной позицией
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async reorderProjects(body: GitlabServicesMtsRuMtsMediaCorporateCorporateBackendProjectsReorderProjectsRequest, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<string>> {
            const localVarAxiosArgs = await ProjectsApiAxiosParamCreator(configuration).reorderProjects(body, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * Сохранение проекта
         * @summary Сохранение проекта
         * @param {GitlabServicesMtsRuMtsMediaCorporateCorporateBackendProjectsProject} body Сохранение проекта в хранилище
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async saveProject(body: GitlabServicesMtsRuMtsMediaCorporateCorporateBackendProjectsProject, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GitlabServicesMtsRuMtsMediaCorporateCorporateBackendProjectsProject>> {
            const localVarAxiosArgs = await ProjectsApiAxiosParamCreator(configuration).saveProject(body, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
    }
};

/**
 * ProjectsApi - factory interface
 * @export
 */
export const ProjectsApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    return {
        /**
         * Удаление проекта
         * @summary Удаление проекта
         * @param {string} uid identificator of project
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteProject(uid: string, options?: any): AxiosPromise<string> {
            return ProjectsApiFp(configuration).deleteProject(uid, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Endpoint for download files from public location
         * @param {string} uid Имя скачиваемого файла
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        dowloadProjectsImagesPublic(uid: string, options?: any): AxiosPromise<string> {
            return ProjectsApiFp(configuration).dowloadProjectsImagesPublic(uid, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Получение размера коллекции в соотвествии с фильтром
         * @param {string} [dateFromStart] Фильтр по дате начала от 2006-01-02T15:04:05.000Z
         * @param {string} [dateFromEnd] Фильтр по дате начала до 2006-01-02T15:04:05.000Z
         * @param {number} [projectAssessmentFrom] Фильтр по стоимости  от
         * @param {number} [projectAssessmentTo] Фильтр по стоимости до
         * @param {Array&lt;number&gt;} [genre] Фильтр по жанру
         * @param {Array&lt;number&gt;} [projectStatus] Фильтр по статусу проекта
         * @param {Array&lt;number&gt;} [ProjectType] Фильтр по типу проекта
         * @param {string} [searchString] Фильтр по наименованию+режиссеру+продюсеру
         * @param {Array&lt;number&gt;} [SpecialCategoryType] Фильтрация по лидер / премьера
         * @param {string} [author] Фильтр по автору (me -  текущий пользователь)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getProjectCollectionSize(dateFromStart?: string, dateFromEnd?: string, projectAssessmentFrom?: number, projectAssessmentTo?: number, genre?: Array<number>, projectStatus?: Array<number>, ProjectType?: Array<number>, searchString?: string, SpecialCategoryType?: Array<number>, author?: string, options?: any): AxiosPromise<number> {
            return ProjectsApiFp(configuration).getProjectCollectionSize(dateFromStart, dateFromEnd, projectAssessmentFrom, projectAssessmentTo, genre, projectStatus, ProjectType, searchString, SpecialCategoryType, author, options).then((request) => request(axios, basePath));
        },
        /**
         * Получение проекта по id
         * @summary Получение проекта по id
         * @param {string} id identificator of project
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getProjectEntity(id: string, options?: any): AxiosPromise<GitlabServicesMtsRuMtsMediaCorporateCorporateBackendProjectsProject> {
            return ProjectsApiFp(configuration).getProjectEntity(id, options).then((request) => request(axios, basePath));
        },
        /**
         * Получение опубликованного проекта по id (неавторизованая зона)
         * @summary Получение опубликованного проекта по id (неавторизованая зона)
         * @param {string} id Id опубликованного проекта
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getProjectPublishedEntity(id: string, options?: any): AxiosPromise<GitlabServicesMtsRuMtsMediaCorporateBackendProjectsProject> {
            return ProjectsApiFp(configuration).getProjectPublishedEntity(id, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Получение коллекции в соотвествии с фильтром
         * @param {number} [size] Количество выдаваемых строк, по умолчанию 10
         * @param {number} [offset] Смещение от начала
         * @param {string} [dateFromStart] Фильтр по дате начала от 2006-01-02T15:04:05.000Z
         * @param {string} [dateFromEnd] Фильтр по дате начала до 2006-01-02T15:04:05.000Z
         * @param {boolean} [displayOnHomePage] При передаче значения true будут выданы только проекты с флагом -показывать на главной-
         * @param {number} [projectAssessmentFrom] Фильтр по стоимости от
         * @param {number} [projectAssessmentTo] Фильтр по стоимости до
         * @param {Array&lt;number&gt;} [genre] Фильтр по жанру
         * @param {Array&lt;number&gt;} [projectStatus] Фильтр по статусу проекта
         * @param {Array&lt;number&gt;} [ProjectType] Фильтр по типу проекта
         * @param {string} [sortField] Сортировка по полю
         * @param {number} [sortDirection] направление сортировки
         * @param {Array&lt;number&gt;} [SpecialCategoryType] Фильтрация по лидер / премьера
         * @param {string} [searchString] Фильтр по наименованию+режиссеру+продюсеру
         * @param {string} [author] Фильтр по автору (me - текущий пользователь)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getProjectsListFilter(size?: number, offset?: number, dateFromStart?: string, dateFromEnd?: string, displayOnHomePage?: boolean, projectAssessmentFrom?: number, projectAssessmentTo?: number, genre?: Array<number>, projectStatus?: Array<number>, ProjectType?: Array<number>, sortField?: string, sortDirection?: number, SpecialCategoryType?: Array<number>, searchString?: string, author?: string, options?: any): AxiosPromise<Array<GitlabServicesMtsRuMtsMediaCorporateCorporateBackendProjectsProject>> {
            return ProjectsApiFp(configuration).getProjectsListFilter(size, offset, dateFromStart, dateFromEnd, displayOnHomePage, projectAssessmentFrom, projectAssessmentTo, genre, projectStatus, ProjectType, sortField, sortDirection, SpecialCategoryType, searchString, author, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Получение списка опубликованных проектов (неавторизованая зона)
         * @param {number} [size] Количество выдаваемых строк, по умолчанию 10
         * @param {number} [offset] Смещение от начала
         * @param {boolean} [displayOnHomePage] При передаче значения true будут выданы только проекты с флагом -показывать на главной-
         * @param {Array&lt;number&gt;} [ProjectType] Фильтр по типу проекта
         * @param {string} [searchString] Фильтр по наименованию+режиссеру+продюсеру
         * @param {Array&lt;number&gt;} [genre] Фильтр по жанру
         * @param {string} [sortField] Сортировка по полю
         * @param {number} [sortDirection] направление сортировки
         * @param {Array&lt;number&gt;} [SpecialCategoryType] Фильтрация по лидер (1) / премьера (2)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getProjectsListPublished(size?: number, offset?: number, displayOnHomePage?: boolean, ProjectType?: Array<number>, searchString?: string, genre?: Array<number>, sortField?: string, sortDirection?: number, SpecialCategoryType?: Array<number>, options?: any): AxiosPromise<GitlabServicesMtsRuMtsMediaCorporateBackendProjectsCountableResult> {
            return ProjectsApiFp(configuration).getProjectsListPublished(size, offset, displayOnHomePage, ProjectType, searchString, genre, sortField, sortDirection, SpecialCategoryType, options).then((request) => request(axios, basePath));
        },
        /**
         * Получение списка проектов в соответствии с фильтром + дополнительно черновик по id
         * @summary Получение списка проектов в соответствии с фильтром + дополнительно черновик по id
         * @param {string} id id проекта-черновика, которого надо присоединить к результату
         * @param {number} [size] Количество выдаваемых строк, по умолчанию 10
         * @param {number} [offset] Смещение от начала
         * @param {boolean} [displayOnHomePage] При передаче значения true будут выданы только проекты с флагом -показывать на главной-
         * @param {Array&lt;number&gt;} [ProjectType] Фильтр по типу проекта
         * @param {string} [searchString] Фильтр по наименованию+режиссеру+продюсеру
         * @param {Array&lt;number&gt;} [genre] Фильтр по жанру
         * @param {string} [sortField] Сортировка по полю
         * @param {number} [sortDirection] направление сортировки
         * @param {Array&lt;number&gt;} [SpecialCategoryType] Фильтрация по лидер (1) / премьера (2)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getProjectsListWithDraft(id: string, size?: number, offset?: number, displayOnHomePage?: boolean, ProjectType?: Array<number>, searchString?: string, genre?: Array<number>, sortField?: string, sortDirection?: number, SpecialCategoryType?: Array<number>, options?: any): AxiosPromise<GitlabServicesMtsRuMtsMediaCorporateCorporateBackendProjectsCountableResult> {
            return ProjectsApiFp(configuration).getProjectsListWithDraft(id, size, offset, displayOnHomePage, ProjectType, searchString, genre, sortField, sortDirection, SpecialCategoryType, options).then((request) => request(axios, basePath));
        },
        /**
         * Получение справочников РМ управления проектами
         * @summary Получение справочников
         * @param {string} name Значения: genre, age_restrictions, production_status, roles status, type, special_category
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getProjectsReferences(name: string, options?: any): AxiosPromise<Array<ContractsReference>> {
            return ProjectsApiFp(configuration).getProjectsReferences(name, options).then((request) => request(axios, basePath));
        },
        /**
         * Изменение параметров существующего проекта (метод доступен только модератору)
         * @summary Изменение параметров проекта
         * @param {GitlabServicesMtsRuMtsMediaCorporateCorporateBackendProjectsPathProjectRequest} body Информация о новом пользователе
         * @param {string} uid Идентификатор пользователя
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        pathProject(body: GitlabServicesMtsRuMtsMediaCorporateCorporateBackendProjectsPathProjectRequest, uid: string, options?: any): AxiosPromise<GitlabServicesMtsRuMtsMediaCorporateCorporateBackendProjectsProject> {
            return ProjectsApiFp(configuration).pathProject(body, uid, options).then((request) => request(axios, basePath));
        },
        /**
         * Изменение позиции существующих проектов (перетаскивание проктов в списке проектов)
         * @summary Изменение параметров проекта
         * @param {GitlabServicesMtsRuMtsMediaCorporateCorporateBackendProjectsReorderProjectsRequest} body Информация о проектах с измененной позицией
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        reorderProjects(body: GitlabServicesMtsRuMtsMediaCorporateCorporateBackendProjectsReorderProjectsRequest, options?: any): AxiosPromise<string> {
            return ProjectsApiFp(configuration).reorderProjects(body, options).then((request) => request(axios, basePath));
        },
        /**
         * Сохранение проекта
         * @summary Сохранение проекта
         * @param {GitlabServicesMtsRuMtsMediaCorporateCorporateBackendProjectsProject} body Сохранение проекта в хранилище
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        saveProject(body: GitlabServicesMtsRuMtsMediaCorporateCorporateBackendProjectsProject, options?: any): AxiosPromise<GitlabServicesMtsRuMtsMediaCorporateCorporateBackendProjectsProject> {
            return ProjectsApiFp(configuration).saveProject(body, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * ProjectsApi - object-oriented interface
 * @export
 * @class ProjectsApi
 * @extends {BaseAPI}
 */
export class ProjectsApi extends BaseAPI {
    /**
     * Удаление проекта
     * @summary Удаление проекта
     * @param {string} uid identificator of project
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ProjectsApi
     */
    public deleteProject(uid: string, options?: any) {
        return ProjectsApiFp(this.configuration).deleteProject(uid, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     * 
     * @summary Endpoint for download files from public location
     * @param {string} uid Имя скачиваемого файла
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ProjectsApi
     */
    public dowloadProjectsImagesPublic(uid: string, options?: any) {
        return ProjectsApiFp(this.configuration).dowloadProjectsImagesPublic(uid, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     * 
     * @summary Получение размера коллекции в соотвествии с фильтром
     * @param {string} [dateFromStart] Фильтр по дате начала от 2006-01-02T15:04:05.000Z
     * @param {string} [dateFromEnd] Фильтр по дате начала до 2006-01-02T15:04:05.000Z
     * @param {number} [projectAssessmentFrom] Фильтр по стоимости  от
     * @param {number} [projectAssessmentTo] Фильтр по стоимости до
     * @param {Array&lt;number&gt;} [genre] Фильтр по жанру
     * @param {Array&lt;number&gt;} [projectStatus] Фильтр по статусу проекта
     * @param {Array&lt;number&gt;} [ProjectType] Фильтр по типу проекта
     * @param {string} [searchString] Фильтр по наименованию+режиссеру+продюсеру
     * @param {Array&lt;number&gt;} [SpecialCategoryType] Фильтрация по лидер / премьера
     * @param {string} [author] Фильтр по автору (me -  текущий пользователь)
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ProjectsApi
     */
    public getProjectCollectionSize(dateFromStart?: string, dateFromEnd?: string, projectAssessmentFrom?: number, projectAssessmentTo?: number, genre?: Array<number>, projectStatus?: Array<number>, ProjectType?: Array<number>, searchString?: string, SpecialCategoryType?: Array<number>, author?: string, options?: any) {
        return ProjectsApiFp(this.configuration).getProjectCollectionSize(dateFromStart, dateFromEnd, projectAssessmentFrom, projectAssessmentTo, genre, projectStatus, ProjectType, searchString, SpecialCategoryType, author, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     * Получение проекта по id
     * @summary Получение проекта по id
     * @param {string} id identificator of project
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ProjectsApi
     */
    public getProjectEntity(id: string, options?: any) {
        return ProjectsApiFp(this.configuration).getProjectEntity(id, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     * Получение опубликованного проекта по id (неавторизованая зона)
     * @summary Получение опубликованного проекта по id (неавторизованая зона)
     * @param {string} id Id опубликованного проекта
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ProjectsApi
     */
    public getProjectPublishedEntity(id: string, options?: any) {
        return ProjectsApiFp(this.configuration).getProjectPublishedEntity(id, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     * 
     * @summary Получение коллекции в соотвествии с фильтром
     * @param {number} [size] Количество выдаваемых строк, по умолчанию 10
     * @param {number} [offset] Смещение от начала
     * @param {string} [dateFromStart] Фильтр по дате начала от 2006-01-02T15:04:05.000Z
     * @param {string} [dateFromEnd] Фильтр по дате начала до 2006-01-02T15:04:05.000Z
     * @param {boolean} [displayOnHomePage] При передаче значения true будут выданы только проекты с флагом -показывать на главной-
     * @param {number} [projectAssessmentFrom] Фильтр по стоимости от
     * @param {number} [projectAssessmentTo] Фильтр по стоимости до
     * @param {Array&lt;number&gt;} [genre] Фильтр по жанру
     * @param {Array&lt;number&gt;} [projectStatus] Фильтр по статусу проекта
     * @param {Array&lt;number&gt;} [ProjectType] Фильтр по типу проекта
     * @param {string} [sortField] Сортировка по полю
     * @param {number} [sortDirection] направление сортировки
     * @param {Array&lt;number&gt;} [SpecialCategoryType] Фильтрация по лидер / премьера
     * @param {string} [searchString] Фильтр по наименованию+режиссеру+продюсеру
     * @param {string} [author] Фильтр по автору (me - текущий пользователь)
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ProjectsApi
     */
    public getProjectsListFilter(size?: number, offset?: number, dateFromStart?: string, dateFromEnd?: string, displayOnHomePage?: boolean, projectAssessmentFrom?: number, projectAssessmentTo?: number, genre?: Array<number>, projectStatus?: Array<number>, ProjectType?: Array<number>, sortField?: string, sortDirection?: number, SpecialCategoryType?: Array<number>, searchString?: string, author?: string, options?: any) {
        return ProjectsApiFp(this.configuration).getProjectsListFilter(size, offset, dateFromStart, dateFromEnd, displayOnHomePage, projectAssessmentFrom, projectAssessmentTo, genre, projectStatus, ProjectType, sortField, sortDirection, SpecialCategoryType, searchString, author, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     * 
     * @summary Получение списка опубликованных проектов (неавторизованая зона)
     * @param {number} [size] Количество выдаваемых строк, по умолчанию 10
     * @param {number} [offset] Смещение от начала
     * @param {boolean} [displayOnHomePage] При передаче значения true будут выданы только проекты с флагом -показывать на главной-
     * @param {Array&lt;number&gt;} [ProjectType] Фильтр по типу проекта
     * @param {string} [searchString] Фильтр по наименованию+режиссеру+продюсеру
     * @param {Array&lt;number&gt;} [genre] Фильтр по жанру
     * @param {string} [sortField] Сортировка по полю
     * @param {number} [sortDirection] направление сортировки
     * @param {Array&lt;number&gt;} [SpecialCategoryType] Фильтрация по лидер (1) / премьера (2)
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ProjectsApi
     */
    public getProjectsListPublished(size?: number, offset?: number, displayOnHomePage?: boolean, ProjectType?: Array<number>, searchString?: string, genre?: Array<number>, sortField?: string, sortDirection?: number, SpecialCategoryType?: Array<number>, options?: any) {
        return ProjectsApiFp(this.configuration).getProjectsListPublished(size, offset, displayOnHomePage, ProjectType, searchString, genre, sortField, sortDirection, SpecialCategoryType, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     * Получение списка проектов в соответствии с фильтром + дополнительно черновик по id
     * @summary Получение списка проектов в соответствии с фильтром + дополнительно черновик по id
     * @param {string} id id проекта-черновика, которого надо присоединить к результату
     * @param {number} [size] Количество выдаваемых строк, по умолчанию 10
     * @param {number} [offset] Смещение от начала
     * @param {boolean} [displayOnHomePage] При передаче значения true будут выданы только проекты с флагом -показывать на главной-
     * @param {Array&lt;number&gt;} [ProjectType] Фильтр по типу проекта
     * @param {string} [searchString] Фильтр по наименованию+режиссеру+продюсеру
     * @param {Array&lt;number&gt;} [genre] Фильтр по жанру
     * @param {string} [sortField] Сортировка по полю
     * @param {number} [sortDirection] направление сортировки
     * @param {Array&lt;number&gt;} [SpecialCategoryType] Фильтрация по лидер (1) / премьера (2)
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ProjectsApi
     */
    public getProjectsListWithDraft(id: string, size?: number, offset?: number, displayOnHomePage?: boolean, ProjectType?: Array<number>, searchString?: string, genre?: Array<number>, sortField?: string, sortDirection?: number, SpecialCategoryType?: Array<number>, options?: any) {
        return ProjectsApiFp(this.configuration).getProjectsListWithDraft(id, size, offset, displayOnHomePage, ProjectType, searchString, genre, sortField, sortDirection, SpecialCategoryType, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     * Получение справочников РМ управления проектами
     * @summary Получение справочников
     * @param {string} name Значения: genre, age_restrictions, production_status, roles status, type, special_category
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ProjectsApi
     */
    public getProjectsReferences(name: string, options?: any) {
        return ProjectsApiFp(this.configuration).getProjectsReferences(name, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     * Изменение параметров существующего проекта (метод доступен только модератору)
     * @summary Изменение параметров проекта
     * @param {GitlabServicesMtsRuMtsMediaCorporateCorporateBackendProjectsPathProjectRequest} body Информация о новом пользователе
     * @param {string} uid Идентификатор пользователя
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ProjectsApi
     */
    public pathProject(body: GitlabServicesMtsRuMtsMediaCorporateCorporateBackendProjectsPathProjectRequest, uid: string, options?: any) {
        return ProjectsApiFp(this.configuration).pathProject(body, uid, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     * Изменение позиции существующих проектов (перетаскивание проктов в списке проектов)
     * @summary Изменение параметров проекта
     * @param {GitlabServicesMtsRuMtsMediaCorporateCorporateBackendProjectsReorderProjectsRequest} body Информация о проектах с измененной позицией
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ProjectsApi
     */
    public reorderProjects(body: GitlabServicesMtsRuMtsMediaCorporateCorporateBackendProjectsReorderProjectsRequest, options?: any) {
        return ProjectsApiFp(this.configuration).reorderProjects(body, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     * Сохранение проекта
     * @summary Сохранение проекта
     * @param {GitlabServicesMtsRuMtsMediaCorporateCorporateBackendProjectsProject} body Сохранение проекта в хранилище
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ProjectsApi
     */
    public saveProject(body: GitlabServicesMtsRuMtsMediaCorporateCorporateBackendProjectsProject, options?: any) {
        return ProjectsApiFp(this.configuration).saveProject(body, options).then((request) => request(this.axios, this.basePath));
    }
}
